
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pocs",
      function () {
        return require("private-next-pages/pocs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pocs"])
      });
    }
  